webpackJsonp([230856922451730],{

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommentList = function CommentList(_ref) {
	  var by = _ref.by,
	      timeISO = _ref.timeISO,
	      text = _ref.text;
	  return Glamor.createElement(
	    'div',
	    {
	      css: {
	        padding: '1rem 0'
	      }
	    },
	    Glamor.createElement('div', {
	      css: {
	        backgroundColor: '#f5f5f5',
	        margin: '0 0 1.5rem',
	        padding: '1rem 1.5rem',
	        '& p': {
	          margin: '1rem 0'
	        },
	        '& a': {
	          color: '#0274b3',
	          textDecoration: 'none'
	        },
	        '& a:hover': {
	          textDecoration: 'underline'
	        }
	      },
	      dangerouslySetInnerHTML: {
	        __html: text
	      }
	    }),
	    Glamor.createElement(
	      'p',
	      null,
	      Glamor.createElement(
	        'em',
	        null,
	        by
	      ),
	      ' - ',
	      timeISO
	    )
	  );
	};
	
	CommentList.propTypes = {
	  text: _propTypes2.default.string,
	  by: _propTypes2.default.string,
	  timeISO: _propTypes2.default.string
	};
	
	exports.default = CommentList;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _commentListItem = __webpack_require__(206);
	
	var _commentListItem2 = _interopRequireDefault(_commentListItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HackerNewsComment = function HackerNewsComment(_ref) {
	  var pathContext = _ref.pathContext;
	  return Glamor.createElement(
	    'div',
	    {
	      css: {
	        margin: '2rem 1rem'
	      }
	    },
	    Glamor.createElement(
	      'h1',
	      null,
	      pathContext.title
	    ),
	    Glamor.createElement(
	      'p',
	      null,
	      'By ',
	      pathContext.by,
	      ' - ',
	      pathContext.createdAt
	    ),
	    Glamor.createElement(
	      'p',
	      {
	        css: {
	          fontSize: '15px',
	          margin: '0 0 2rem'
	        }
	      },
	      Glamor.createElement(
	        'em',
	        null,
	        'Showing first level comment(s)'
	      )
	    ),
	    Glamor.createElement(
	      'div',
	      { css: { margin: '2rem 0' } },
	      pathContext.comments.length ? pathContext.comments.map(function (comment, index) {
	        return Glamor.createElement(_commentListItem2.default, _extends({ key: index }, comment));
	      }) : Glamor.createElement(
	        'div',
	        {
	          css: {
	            backgroundColor: '#f5f5f5',
	            padding: '1rem 1.5rem'
	          }
	        },
	        Glamor.createElement(
	          'p',
	          {
	            css: {
	              margin: '0'
	            }
	          },
	          'No comments for this story/post.'
	        )
	      )
	    )
	  );
	};
	
	HackerNewsComment.propTypes = {
	  pathContext: _propTypes2.default.shape({
	    title: _propTypes2.default.string,
	    by: _propTypes2.default.string,
	    createdAt: _propTypes2.default.string,
	    comments: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	      text: _propTypes2.default.string,
	      by: _propTypes2.default.string,
	      timeISO: _propTypes2.default.string
	    }))
	  })
	};
	
	exports.default = HackerNewsComment;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-hacker-news-comment-js-6310d1041d955e47f1f8.js